export enum UserRole {
  PortalAdmin = 0,
  CarrierAdmin = 1 << 0,
  CarrierUser = CarrierAdmin << 1,
  Public = CarrierUser << 1,
  Unknown = Public << 1,
  BusinessAdmin = Unknown << 1,
  CarrierAdminAndCarrierUser = CarrierAdmin | CarrierUser,
}

export const UserRoleLabel = new Map<number, string>([
  [UserRole.PortalAdmin, 'Portal admin'],
  [UserRole.CarrierAdmin, 'Carrier admin'],
  [UserRole.CarrierUser, 'Carrier user'],
  [UserRole.Public, 'Public'],
  [UserRole.Unknown, 'Unknown'],
  [UserRole.BusinessAdmin, 'Business admin'],
]);

// higher index means higher in the hierarchy
export const UserRoleHierarchy = [
  UserRole.Unknown,
  UserRole.Public,
  UserRole.CarrierUser,
  UserRole.CarrierAdmin,
  UserRole.BusinessAdmin,
  UserRole.PortalAdmin,
];

export function IsHigherInHierarchy(toCheck: UserRole, versus: UserRole): boolean | undefined {
  if (
    !UserRoleHierarchy.includes(toCheck) ||
    !UserRoleHierarchy.includes(versus)
  ) {
    return false;
  }

  const toCheckHierarchyIndex = UserRoleHierarchy.indexOf(toCheck);
  const versusHierarchyIndex = UserRoleHierarchy.indexOf(versus);

  return toCheckHierarchyIndex > versusHierarchyIndex;
}
